/** Import Libs */
import "./FooterScripts/Libs/jquery-global";
import "bootstrap/dist/js/bootstrap";
import "./FooterScripts/Libs/04_BrowserDetection";

/** Usercentrics Event Listeners **/
import "./UsercentricsHelper/UserCentricsEventListeners";

/** Import and initialize, new code-standard **/
import CheckoutVideo from "./FooterScripts/Components/05_CheckoutVideo";

const initNodeTypesOnLoad = function () {
    // scripts with cookie dependency listeners first
    new HubspotFormsInit()
    // other scripts below to avoid adding event listener to late
    new CheckoutVideo()
}

if (document.readyState !== 'loading') {
    initNodeTypesOnLoad()
} else {
    document.addEventListener('DOMContentLoaded', initNodeTypesOnLoad)
}

/** Import files with old code-standard **/

/** Import Components */
import "./FooterScripts/Components/01_ClosestPolyfill";
import "./FooterScripts/Components/02_DOMReadyUtility";
import "./FooterScripts/Components/03_ClassListPolyfill";
import "./FooterScripts/Components/04_ObjectFitPolyFill";
import "./FooterScripts/Components/ContractsOrderChangeInCarousel";
import "./FooterScripts/Components/IFrame";
import "./FooterScripts/Components/MobileHeaderVisibility";
import "./FooterScripts/Components/Navigation";
import "./FooterScripts/Components/NavigationBackgroundOnScroll";
import "./FooterScripts/Components/Parallax";
import "./FooterScripts/Components/ScrollToTop";
import "./FooterScripts/Components/StickySidebar";
import "./FooterScripts/Components/VideoStage";
import "./FooterScripts/Components/TechDivisionCompare";

/** Import Jumpers.Studios JS */
import "./../../../../Jumpers.Studios/Resources/Private/JavaScript/FooterScripts/StudioFavourite";
import "./../../../../Jumpers.Studios/Resources/Private/JavaScript/FooterScripts/StudioSelect";
import "./../../../../Jumpers.Studios/Resources/Private/JavaScript/FooterScripts/StudioMap";

/** Import TechDivision.Accordion JS */
import "./../../../../TechDivision.Accordion/Resources/Private/JavaScript/Collapsible";

/** Import Jumpers.Forms JS */
import HubspotFormsInit from "./Hubspot/HubspotFormLoader";

